import React from "react";
import styled from "styled-components";
import moment from "moment";
import { ChevronDown } from "@sonder/ui/source/icons";
import { DateTimePicker } from "@sonder/ui/source/styled/components/DateTimePicker";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { setSelectedDate } from "history/actions";
import { useStore } from "history/store";

const Container = styled.div`
  display: flex;
`;

const createTrigger = (date: moment.Moment | null) => (
  <Button iconRight>
    {date && date.format("MMMM Do")}
    <ChevronDown />
  </Button>
);

export const HistoryDatePicker = () => {
  const { dispatch, state: historyState } = useStore();
  const { selectedDate } = historyState;

  return (
    <Container>
      <Dropdown trigger={createTrigger(selectedDate)}>
        {({ isOpen }) =>
          isOpen && (
            <DropdownContent>
              <DateTimePicker
                date={selectedDate}
                isOutsideRange={day =>
                  day ? day.isAfter(moment().endOf("day")) : true
                }
                onDateChange={nextDate => {
                  if (nextDate) dispatch(setSelectedDate(nextDate));
                }}
              />
            </DropdownContent>
          )
        }
      </Dropdown>
    </Container>
  );
};
